module.exports = __webpack_public_path__ + "static/img/katakana_large_me-compressor.72d3bf3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/katakana_large_me-compressor.gif
// module id = 4dWI
// module chunks = 0